export const getTranslations = (t, authorData) => {
  return {
    continueShopping: t("kf.cart.label.continueShopping"),
    yourBasket: t("kf.cart.label.yourCart"),
    emptyBasket: t("kf.cart.label.emptyCart"),
    noItemsToShip: t("kf.cart.label.noItemsToShip"),
    outOfStock: authorData.outOfStock
      ? authorData.outOfStock
      : t("kf.cart.label.outOfStock"),
    quantityLabel: t("kf.cart.label.quantity"),
    totalLabel: t("kf.cart.label.total"),
    noItems: t("kf.cart.label.noItemsInCart"),
    addItems: t("kf.cart.label.addItems"),
    remove: t("kf.cart.label.remove"),
    standardShipping: t("kf.cart.label.standardShipping"),
    availableToShip: qty =>
      authorData.qtyMoreThanInventory
        ? authorData.qtyMoreThanInventory?.replace("{qty}", qty)
        : t("kf.cart.label.availableToShip", { qty: qty }),
    downloadGuide: t("kf.cart.label.downloadGuide"),
    needTime: authorData.needMoreTime
      ? authorData.needMoreTime
      : t("kf.cart.label.needTime"),
    saveBasket: authorData.saveCartMssg
      ? authorData.saveCartMssg
      : t("kf.cart.label.saveBasket"),
    createAccount: t("kf.cart.label.createAccountLink"),
    basketIndefinitely: t("kf.cart.label.basketIndefinitely"),
    sharedInvitation: t("kf.cart.label.sharedInvitation"),
    shareBasket: t("kf.cart.label.shareCart"),
    collaborators: authorData.shareCartDesc
      ? authorData.shareCartDesc
      : t("kf.cart.label.collaborators"),
    cartAttention: authorData.outOfStockAlert
      ? authorData.outOfStockAlert
      : t("kf.cart.label.cartAttention"),
    estimatedTotal: t("kf.cart.label.estimatedTotal"),
    continueCheckout: t("kf.cart.label.continueCheckout"),
    invalidPromoErr: t("kf.cart.error.invalidPromoErr"),
    noPromoErr: t("kf.cart.error.noPromoErr"),
    promotions: authorData.totalPromotions
      ? authorData.totalPromotions
      : t("kf.cart.label.totalPromotions"),
    subTotals: t("kf.cart.label.subTotal"),
    deliveryType: t("kf.cart.label.deliveryType"),
    standardFree: t("kf.cart.label.standardFree"),
    vat: t("kf.cart.label.vat"),
    OrderSummaryLabel: t("kf.cart.label.orderSummary"),
    applyPromo: t("kf.promo.button.apply"),
    enterPromo: authorData.enterPromo
      ? authorData.enterPromo
      : t("kf.cart.label.enterPromo"),
    orderTotal: t("kf.checkout.label.total"),
    quantity: t("kf.cart.label.quantity"),
    colorFinish: t("kf.cart.label.colorFinish"),
    total: t("kf.cart.label.total"),
    getCartError: t("kf.cart.label.getCartError"),
    productNo: sku => t("kf.cart.label.productNo", { sku: sku }),
    totalSaved: total => t("kf.cart.label.totalSaved", { total: total }),
    previousDiscountRemove: t("kf.cart.error.previousDiscountErr"),
    combinePromoErr: t("kf.cart.error.combinePromoErr"),
    maxAppReachedErr: t("kf.cart.error.maxAppReachedErr"),
    promoNotApplicable: t("kf.cart.error.promoNotApplicable"),
    productDiscounts: t("kf.cart.label.productDiscounts"),
  }
}
